import {create} from "zustand";
import { TransactionListItemResponseDto, TransactionType } from '@/features/transactions/types/transactions-dto';

const DEFAULT_PAGE_SIZE = 10;

type TransactionsFilterType = {
    filter: {
        startDate?: Date | null;
        endDate?: Date | null;
        take: number;
        skip?: number;
        amountRange?: string | null;
        apartmentId?: { 
            id: string;
            name?: string;
        }[];
        account?: TransactionType | null;
        orderBy?: Capitalize<keyof TransactionListItemResponseDto> | null;
        orderDirection: 'asc' | 'desc';
    },
    setFilter: ( filter: Partial<TransactionsFilterType['filter']> ) => void;
    resetFilter: () => void;
};

const defaultState: TransactionsFilterType['filter'] = {
    startDate: null,
    endDate: null,
    take: DEFAULT_PAGE_SIZE,
    skip: 0, 
    amountRange: null, 
    apartmentId: [], 
    account: null, 
    orderBy: null, 
    orderDirection: 'asc', 
};

export const useTransactionsFilter = create<TransactionsFilterType>((set) => ({
    filter: {...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ 
            filter: {...defaultState },
        });
    },
}));